import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';

const PrintProgress = () => (
    <div className="text-center mt-5">
        <h1><FormattedMessage {...messages.dashboard.print.loading} /></h1>
    </div>
);

export default PrintProgress;
